const DomainTypes = {
    CorrelationId: Symbol.for('CorrelationId'),
};

export default DomainTypes;